var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIosqrCode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_44_9823)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.229578 80.6541V84.2904V87.9268H3.86594V84.2904H7.5023V80.6541H3.86594H0.229578Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.86594 37.018H7.5023V33.3816H3.86594H0.229578V37.018V40.6543H3.86594V37.018Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50231 26.1088H25.6841V0.654297H0.229584V26.1088H7.50231ZM3.86595 18.8361V4.29066H22.0478V22.4725H3.86595V18.8361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.50238 51.5633H11.1387V47.9269H14.7751H18.4115V44.2905H14.7751H11.1387H7.50238H3.86602V47.9269H7.50238V51.5633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1387 37.0178H7.50231V40.6542H11.1387V37.0178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1387 102.472H7.50231V106.109V109.745V113.381H11.1387H14.775H18.4114V109.745V106.109V102.472H14.775H11.1387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.775 62.472V58.8356H11.1387V55.1992H3.86594V47.9265H0.229578V73.3811H3.86594V77.0174H7.50231V80.6538H14.775V77.0174H11.1387V73.3811H14.775V69.7447H18.4114V66.1083H14.775V62.472ZM11.1387 69.7447H7.50231V62.472H11.1387V69.7447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.775 18.836H18.4114V15.1996V11.5632V7.92688H14.775H11.1387H7.50231V11.5632V15.1996V18.836H11.1387H14.775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4113 84.2908H14.775V87.9271H18.4113V84.2908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4113 55.1995H14.775V58.8358H18.4113V55.1995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4114 33.3812V29.7449H14.775H11.1387V33.3812H14.775V37.0176V40.654H18.4114V37.0176V33.3812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4114 95.1997H0.229578V120.654H25.6841V95.1997H18.4114ZM22.0478 102.472V117.018H3.86594V98.8361H22.0478V102.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4114 87.9268V91.5631H22.0478H25.6842V87.9268H22.0478H18.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0478 40.6545H18.4114V44.2909H22.0478V40.6545Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6842 84.2904V80.6541H22.0478H18.4114V84.2904H22.0478H25.6842Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6842 44.2905H22.0478V47.9269H25.6842V44.2905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6842 37.0178H22.0478V40.6542H25.6842V37.0178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3206 77.0175V73.3811H25.6842H22.0478V77.0175H25.6842V80.6538H29.3206V77.0175Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3205 98.8361V102.472H32.9569V98.8361V95.1997H29.3205V98.8361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9569 44.2905V47.9269H36.5933V44.2905V40.6542H40.2296V37.0178H36.5933H32.9569V40.6542H29.3205H25.6842V44.2905H29.3205H32.9569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9569 37.0178V33.3814V29.7451H36.5933V26.1087V22.4723H40.2297V18.836H43.866V15.1996H47.5024V18.836H51.1387V15.1996V11.5632H47.5024H43.866H40.2297V15.1996H36.5933V18.836H32.9569H29.3206V22.4723H32.9569V26.1087H29.3206V29.7451H25.6842H22.0478V33.3814H25.6842V37.0178H29.3206H32.9569Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5933 58.8361H32.9569V62.4724H36.5933V58.8361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5932 51.5629V55.1992H40.2296H43.866H47.5023V51.5629H43.866H40.2296V47.9265H36.5932V51.5629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2296 7.92688H36.5932V11.5632H40.2296V7.92688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2296 4.29066V7.92702H43.866H47.5024H51.1387V11.5634H54.7751V7.92702H58.4114H62.0478H65.6842V11.5634H69.3205V7.92702H72.9569H76.5933V11.5634V15.1997H80.2296V11.5634H83.866V7.92702H80.2296V4.29066H83.866V0.654297H80.2296H76.5933V4.29066H72.9569H69.3205V0.654297H65.6842V4.29066H62.0478H58.4114H54.7751H51.1387V0.654297H47.5024V4.29066H43.866V0.654297H40.2296H36.5933H32.9569V4.29066V7.92702H36.5933V4.29066H40.2296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8659 102.472H40.2296V106.109H36.5932H32.9569H29.3205V109.745H32.9569H36.5932H40.2296V113.381H36.5932V117.018H32.9569H29.3205V120.654H32.9569H36.5932H40.2296V117.018H43.8659V113.381V109.745H47.5023V106.109H43.8659V102.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8659 62.4722H40.2296V66.1085H43.8659V62.4722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8659 33.3816H40.2296V37.018H43.8659V33.3816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5023 58.8361H43.866V62.4724H47.5023V58.8361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5023 37.0178H43.8659V40.6542H40.2296V44.2905V47.9269H43.8659V44.2905H47.5023H51.1386V40.6542H47.5023V37.0178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1388 117.017H47.5024V120.654H51.1388V117.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5024 77.0181V80.6544H51.1388H54.7752V77.0181H51.1388H47.5024Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1388 47.9265H47.5024V51.5629H51.1388V47.9265Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7751 95.1997H51.1387V98.8361H54.7751V95.1997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7751 55.1998V58.8362H51.1387V62.4726H47.5023V66.1089H43.866V69.7453H47.5023H51.1387V73.3817H54.7751V69.7453H58.4114V66.1089H54.7751V62.4726H58.4114V66.1089H62.0478V62.4726H65.6841V58.8362H69.3205V55.1998H65.6841V51.5635H62.0478V55.1998H58.4114V51.5635H54.7751V55.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0477 95.1997H58.4114V98.8361V102.472H62.0477V106.109H65.6841H69.3205H72.9568V102.472H69.3205H65.6841V98.8361H62.0477V95.1997Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0478 91.5629V87.9265H58.4114V84.2901H54.7751H51.1387H47.5024V87.9265V91.5629H43.866H40.2296H36.5933V87.9265H40.2296H43.866V84.2901V80.6538V77.0174V73.3811V69.7447H40.2296V66.1083H36.5933H32.9569H29.3205V62.472V58.8356V55.1992H32.9569V51.5629H29.3205V47.9265H25.6842V51.5629H22.0478V47.9265H18.4114V51.5629V55.1992H22.0478H25.6842V58.8356H22.0478H18.4114V62.472V66.1083H22.0478V62.472H25.6842V66.1083H22.0478V69.7447H25.6842H29.3205V73.3811H32.9569H36.5933V77.0174H40.2296V80.6538H36.5933V77.0174H32.9569V80.6538H29.3205V84.2901H25.6842V87.9265H29.3205V91.5629H32.9569V95.1992H36.5933V98.8356H40.2296V95.1992H43.866V98.8356V102.472H47.5024V106.108H51.1387H54.7751V102.472H51.1387V98.8356H47.5024V95.1992H51.1387V91.5629V87.9265H54.7751V91.5629V95.1992H58.4114V91.5629H62.0478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0477 77.0181H58.4114V80.6544H62.0477V77.0181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0477 69.7451H58.4114V73.3815H62.0477V69.7451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4114 22.4723V18.8359H54.7751H51.1387V22.4723H47.5023H43.866V26.1087V29.745V33.3814H47.5023H51.1387V29.745H47.5023V26.1087H51.1387V29.745H54.7751V26.1087H58.4114H62.0478V22.4723H58.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.4114 11.5632V15.1996V18.836H62.0477V15.1996H65.6841V11.5632H62.0477H58.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0478 109.745V113.382V117.018H58.4114V113.382V109.745H54.7751H51.1387V113.382V117.018H54.7751V120.654H58.4114H62.0478H65.6842H69.3205V117.018H65.6842V113.382H69.3205V109.745H65.6842H62.0478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6842 18.8359H62.0478V22.4723H65.6842V18.8359Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.6842 80.6544H62.0478V84.2908H65.6842H69.3205V80.6544V77.0181H65.6842V80.6544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9568 73.3811H69.3204V77.0175H72.9568V73.3811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.3205 66.1088H65.6842V69.7452H69.3205H72.9569V66.1088V62.4724V58.8361H69.3205V62.4724V66.1088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5932 117.017H72.9568V120.654H76.5932V117.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5932 109.745H80.2296V106.109H76.5932H72.9568V109.745H76.5932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5932 69.7451H72.9568V73.3815H76.5932V69.7451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5933 113.382V117.018H80.2297V120.654H83.866V117.018H87.5024V113.382H83.866V109.745H80.2297V113.382H76.5933Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2297 62.4722H76.5933V66.1085V69.7449H80.2297H83.866V66.1085H80.2297V62.4722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2296 58.8358V55.1995H76.5932H72.9568V58.8358H76.5932H80.2296Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8659 58.8361H80.2296V62.4724H83.8659V58.8361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.866 77.0178H87.5023V73.3815V69.7451H83.866V73.3815V77.0178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 62.4722H83.866V66.1085H87.5023V62.4722Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 7.92702H91.1387V4.29066H94.7751V0.654297H91.1387H87.5023V4.29066H83.866V7.92702H87.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.1387 117.017H87.5024V120.654H91.1387V117.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 113.381H91.1387V109.745V106.109H87.5023H83.866V109.745H87.5023V113.381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5024 80.6544H83.866V84.2908H87.5024V87.9272H83.866H80.2296V84.2908V80.6544H76.5933H72.9569V84.2908H76.5933V87.9272V91.5635H72.9569V87.9272H69.3205V91.5635H65.6842H62.0478V95.1999H65.6842V98.8362H69.3205V95.1999H72.9569V98.8362H76.5933V95.1999H80.2296V98.8362H83.866V95.1999H87.5024V98.8362V102.473H91.1387V98.8362V95.1999V91.5635H94.7751V87.9272H91.1387V84.2908V80.6544V77.0181H87.5024V80.6544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5023 40.6542H83.8659V44.2906V47.9269H80.2296V51.5633H83.8659V55.1996H87.5023V51.5633V47.9269H91.1387V44.2906H94.775V47.9269H98.4114V51.5633H94.775V47.9269H91.1387V51.5633V55.1996H87.5023V58.836V62.4724H91.1387V58.836H94.775H98.4114V62.4724H102.048V58.836V55.1996H105.684H109.32V58.836H105.684V62.4724H102.048V66.1087V69.7451H105.684V66.1087H109.32H112.957V62.4724V58.836H116.593V55.1996H120.23V51.5633H116.593V47.9269H112.957V51.5633H109.32H105.684V47.9269H102.048V44.2906H105.684V40.6542H102.048H98.4114H94.775V37.0178H91.1387V40.6542H87.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4114 22.4728H94.775V26.1091H98.4114V22.4728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.4114 91.5635H102.048V87.9271V84.2908H98.4114H94.775V87.9271H98.4114V91.5635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.048 73.3817H98.4114V69.7454V66.109H94.7751V69.7454V73.3817H91.1387V77.0181H94.7751H98.4114H102.048H105.684V73.3817H102.048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.684 102.472H102.048V106.109V109.745V113.381H105.684H109.321H112.957V109.745V106.109V102.472H109.321H105.684Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 87.9268H105.684V91.5631H109.321V87.9268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 77.0181H105.684V80.6544H109.321V77.0181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 69.7451H105.684V73.3815H109.321V69.7451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 44.2905H105.684V47.9269H109.321V44.2905Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 37.0178H105.684V40.6542H109.321V37.0178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.684 22.4725V18.8361H112.957V7.92702H105.684V11.5634H102.048V15.1998H98.4114V7.92702H105.684V0.654297H98.4114V4.29066H94.7751V11.5634H91.1387V15.1998H87.5024V18.8361H83.866V15.1998H80.2296V22.4725H76.5933V26.1088H72.9569V33.3816H69.3205V37.0179H72.9569V40.6543H65.6842V33.3816H69.3205V26.1088H72.9569V18.8361H69.3205V22.4725H65.6842V26.1088H62.0478V33.3816H51.1387V40.6543H54.7751V37.0179H58.4114V40.6543H54.7751V44.2907H58.4114V51.5634H62.0478V44.2907H65.6842V47.927H69.3205V51.5634H76.5933V44.2907H80.2296V37.0179H76.5933V33.3816H80.2296V29.7452H83.866V26.1088H87.5024V29.7452H83.866V37.0179H91.1387V33.3816H105.684V26.1088H109.321V22.4725H105.684ZM102.048 29.7452H91.1387V18.8361H102.048V29.7452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.321 87.9268H112.957H116.593V84.2904H120.23V80.6541H116.593H112.957H109.321V84.2904V87.9268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.957 73.3811H109.321V77.0175H112.957V73.3811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.957 0.654297H109.321V4.29066H112.957V0.654297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.957 95.1997H94.775V120.654H120.23V95.1997H112.957ZM116.593 102.472V117.018H98.4114V98.8361H116.593V102.472Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 87.9268H116.593V91.5631H120.23V87.9268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.593 66.1088V69.7452H120.23V66.1088V62.4724V58.8361H116.593V62.4724V66.1088Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.593 29.7453H112.957V26.1089H109.321V29.7453V33.3816H112.957V37.018V40.6543V44.2907H116.593H120.23V40.6543H116.593V37.018H120.23V33.3816V29.7453V26.1089H116.593V29.7453Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 15.1998H116.593V18.8362H120.23V15.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.23 4.29028H116.593V7.92665H120.23V4.29028Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_44_9823"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white",
    transform: "translate(0.229584 0.654297)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosqrCode);
export default __webpack_public_path__ + "static/media/ios.qr-code.6a46525ac9c1fb49fb81ef2f504a7580.svg";
export { ForwardRef as ReactComponent };